import baseAPI from '@/api/base';
import { EditAllowanceType, GetAllowanceType, RegisterAllowanceType } from '@/dtos/allowance_type.dto';
import {
  DELETE_ALLOWANCE_TYPE_URL,
  EDIT_ALLOWANCE_TYPE_URL,
  GET_ALLOWANCE_TYPE_URL,
  REGISTER_ALLOWANCE_TYPE_URL,
  TOGGLE_ALLOWANCE_TYPE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class AllowanceType {
  static getAllowanceTypes = async (getAllowanceType: GetAllowanceType): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ALLOWANCE_TYPE_URL, {
      params: getAllowanceType,
    });
    console.log('response', response);
    return response;
  };

  static registerAllowanceType = async (
    registerAllowanceType: RegisterAllowanceType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_ALLOWANCE_TYPE_URL, {
      ...registerAllowanceType,
    });
    console.log('response', response);
    return response;
  };

  static editAllowanceType = async (editAllowanceType: EditAllowanceType): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_ALLOWANCE_TYPE_URL, {
      ...editAllowanceType,
    });
    return response;
  };

  static toggleAllowanceTypeIsActive = async (
    editAllowanceType: EditAllowanceType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ALLOWANCE_TYPE_IS_ACTIVE_URL,
      {
        ...editAllowanceType,
      }
    );
    return response;
  };

  static deleteAllowanceType = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ALLOWANCE_TYPE_URL}/${userId}`
    );
    return response;
  };
}

export default AllowanceType;
